import React, { useEffect, useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import CouponAndVoucherTransactions from "../Coupon&VoucherTransactions/CouponAndVoucherTransactions";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";

const VoucherTransactions = () => {
  const [currentTab, setcurrentTab] = useState("");

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "vouchers") {
      setcurrentTab("vouchers");
    }
  }, []);
  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/dashboard">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">Transactions</p>
          <div className="acc-dashboard mt-4">
            <div className="tabs_ul mb-2">
              <NavLink
                to={""}
                className={currentTab === "vouchers" ? "activeTab" : "tabs_li"}
              >
                Vouchers
              </NavLink>
              <NavLink
                to={"/transactions/coupons"}
                // onClick={(e) => handleToggleTab(0)}
                className={currentTab === "coupons" ? "activeTab" : "tabs_li"}
              >
                Coupons
              </NavLink>
              <NavLink
                to={"/transactions/inner-transactions"}
                // onClick={(e) => handleToggleTab(0)}
                className={currentTab === "transactions" ? "activeTab" : "tabs_li"}
              >
                Transactions
              </NavLink>
            </div>
            <div className="mt-3 vou-trans">
              <CouponAndVoucherTransactions toggle={0} />
            </div>

            {/* <Tabs
              defaultActiveKey="vouchers-dashboard"
              id="uncontrolled-tab-example"
              className="mb-3 my-account"
            >
              <Tab eventKey="vouchers-dashboard" title="Vouchers">
                <VoucherTransactions toggle={0} />
              </Tab>
              <Tab eventKey="manage-vouchers" title="Coupons">
                <VoucherTransactions toggle={1} />
              </Tab>
            </Tabs> */}
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default VoucherTransactions;
